import { queryOptions, skipToken } from '@tanstack/react-query';
import { QueryKey } from 'core/react-query/queryClient';
import { getBoxInvitations } from 'networking/mindfeed/services/box.service';
import type { BoxId } from 'models/Box';

// The pending invitations to a box. No box id: defined, never runs.
export const boxInvitationsQuery = (boxId?: BoxId) =>
  queryOptions({
    queryKey: [QueryKey.BOX_INVITATIONS, boxId],
    queryFn: boxId ? () => getBoxInvitations(boxId) : skipToken,
    staleTime: 5000,
    retry: 1,
  });
